module.exports = __webpack_public_path__ + "img/img8.138d5cee.png";